import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import { useMemo } from "react";

function ChevronRightIcon(props: SvgIconProps) {
  const { fontSize } = props;

  const svgValue = useMemo(() => {
    if (fontSize === "small") {
      return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M6.66669 12L10.6667 8L6.66669 4"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    } else if (fontSize === "large") {
      return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M13.3333 24L21.3333 16L13.3333 8"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    }

    return (
      <svg fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10 18L16 12L10 6"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }, [fontSize]);

  return <SvgIcon {...props}>{svgValue}</SvgIcon>;
}
export default ChevronRightIcon;
